import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { set_current_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { useTranslation } from 'react-i18next';

interface Props {
  workspace: DTO__workspace;
}

export function WSButtonGoToWorkspace({ workspace }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  function onClick() {
    set_current_workspace(workspace._id);
  }

  return (
    <UI_PRIMITIVE__button className="justify-start h-9 text-component-item-foreground" variant="outline-on-component" {...{ onClick }}>
      {t(i18n_page_settings_workspace.tabs.users.personal.button.go_to_workspace.title)}
      <span className="font-bold">{workspace.name}</span>
    </UI_PRIMITIVE__button>
  );
}
